import { IOgqlJobResult, IOgqlV1JobResult } from '@opengov/ogql-types';
import { OrderedMap } from 'immutable';

import { composeStateMachine } from '../../../../module';
import { ReportDataTableAgGridState } from '../records';

export const reportDataTableAgGridInitialState = ReportDataTableAgGridState();

export const reportDataTableAgGridState = composeStateMachine(
  'report-data-table-ag-grid',
  reportDataTableAgGridInitialState,
  (compose) => ({
    setActiveColumn: compose.action((state, column: any) => state.set('activeColumn', column)),
    setJobResult: compose.action((state, jobResult: IOgqlJobResult['jobResult'] | IOgqlV1JobResult['jobResult']) =>
      state.set('jobResult', jobResult)
    ),
    setSumJobResult: compose.action((state, jobResult: IOgqlJobResult['jobResult'] | IOgqlV1JobResult['jobResult']) =>
      state.set('sumJobResult', jobResult)
    ),
    setFilterValuesByColumn: compose.action(
      (state, payload: { columnName: string; filterValues: OrderedMap<string, number> }) =>
        state.setIn(['filterValuesByColumn', payload.columnName], payload.filterValues)
    )
  })
);

export const {
  actions: reportDataTableAgGridActions,
  actionCreators: reportDataTableAgGridActionCreators,
  reducer: reportDataTableAgGridReducer,
  selector: reportDataTableAgGridSelector
} = reportDataTableAgGridState;
